import type { RouteLocationRaw, RouteParamsRaw, RouteRecordRaw } from 'vue-router'

/**
 * Turn a route record into a location a `RouterLink` or `router.push` accepts.
 *
 * Named routes win over paths so a later path change stays transparent. Returns `null`
 * when the record can be neither named nor addressed by path, which lets callers hide a
 * link instead of rendering a dead one.
 */
const buildRouteLocation = (
  route: RouteRecordRaw,
  params?: null | RouteParamsRaw,
  query?: null | Record<string, string>,
): null | RouteLocationRaw => {
  if (typeof route.name === 'string') {
    return {
      name: route.name,
      ...(params ? { params } : {}),
      ...(query ? { query } : {}),
    }
  }

  if (params && Object.keys(params).length > 0) {
    return null
  }

  if (route.path !== '') {
    return query ? { path: route.path, query } : { path: route.path }
  }

  return null
}

export { buildRouteLocation }
